var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFoodGrapes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 43.2",
    style: {
      enableBackground: "new 0 0 60 43.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#7C1C28;stroke:#1A1818;stroke-linejoin:round;}\n\t.st1{fill:#7C1C28;stroke:#1A1818;stroke-width:0.25;stroke-linecap:square;stroke-miterlimit:10;}\n\t.st2{fill:#E82528;stroke:#1A1818;stroke-linecap:round;stroke-linejoin:round;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{font-family:'Helvetica';}\n\t.st5{font-size:4px;}\n\t.st6{fill:#FFE600;}\n\t.st7{fill:#9EC332;stroke:#1A1818;stroke-miterlimit:10;}\n\t.st8{fill:#829E2B;stroke:#1A1818;stroke-miterlimit:10;}\n\t.st9{fill:#72882A;stroke:#1A1818;stroke-miterlimit:10;}\n\t.st10{fill:#8E7320;stroke:#1A1818;stroke-miterlimit:10;}\n\t.st11{fill:#B5C631;stroke:#1A1818;stroke-miterlimit:10;}\n\t.st12{fill:#CEAB42;stroke:#1A1818;stroke-miterlimit:10;}\n\t.st13{fill:#A48629;stroke:#1A1818;stroke-miterlimit:10;}\n\t.st14{fill:#CFCF36;stroke:#1A1818;stroke-miterlimit:10;}\n\t.st15{fill:#FFFFFF;stroke:#1A1818;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1110",
    transform: "translate(-63.007 -50.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1103",
    transform: "translate(63.507 50.126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3420",
    className: "st0",
    d: "M3.6,37.8C3.3,37.8,0,34,0,34L0.1,0.7l3.5,2.9L3.5,37.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3421",
    className: "st1",
    d: "M4,3.3c0,0-4.2-2.9-3.5-2.9S26.1,0,26.1,0s3.2,2.3,3.1,2.7s-2.1,0.1-2.1,0.1L4,3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3422",
    className: "st2",
    d: "M29.2,3.1L29,36.4L3.5,37.8L3.6,3.7L29.2,3.1z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 -6.021350e-03 6.021350e-03 1 6.52 27.392)",
    className: "st3 st4 st5"
  }, "RAISINS"), /*#__PURE__*/React.createElement("g", {
    id: "Group_1102",
    transform: "translate(8.912 6.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3423",
    className: "st6",
    d: "M8.9,2.3L7.9,0l-1,2.5c0.3-0.1,0.7-0.2,1-0.2C8.2,2.2,8.6,2.2,8.9,2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3424",
    className: "st6",
    d: "M5.9,2.8l-2-1.3l0.3,2.6C4.7,3.6,5.3,3.2,5.9,2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3425",
    className: "st6",
    d: "M3.5,4.9l-2.5,0l1.5,1.9C2.7,6.1,3.1,5.5,3.5,4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3426",
    className: "st6",
    d: "M15.8,7.5l-2.3-0.8c0.1,0.3,0.1,0.7,0.1,1c0,0.4,0,0.7-0.1,1.1L15.8,7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3427",
    className: "st6",
    d: "M14.7,3.4L12.3,4c0.4,0.5,0.8,1.1,1,1.7L14.7,3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3428",
    className: "st6",
    d: "M11.8,0.7l-2,1.7c0.6,0.2,1.2,0.5,1.7,0.9L11.8,0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3429",
    className: "st6",
    d: "M3.9,15.9l2-1.7c-0.6-0.2-1.2-0.5-1.7-0.9L3.9,15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3430",
    className: "st6",
    d: "M9.8,13.7l2,1.3l-0.3-2.6C11.1,13,10.5,13.4,9.8,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3431",
    className: "st6",
    d: "M12.3,11.7l2.5,0l-1.5-1.9C13,10.5,12.7,11.1,12.3,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3432",
    className: "st6",
    d: "M2.2,8.9c0-0.4,0-0.7,0.1-1.1L0,9.1l2.3,0.8C2.2,9.6,2.2,9.2,2.2,8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3433",
    className: "st6",
    d: "M1.1,13.1l2.5-0.5c-0.4-0.5-0.8-1.1-1-1.7L1.1,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3434",
    className: "st6",
    d: "M6.9,14.3l1,2.3l1-2.5c-0.3,0.1-0.7,0.2-1,0.2C7.6,14.3,7.2,14.3,6.9,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3435",
    className: "st6",
    d: "M7.9,3c-2.9,0.4-5,2.9-5,5.8c-0.1,2.5,1.8,4.7,4.3,4.8c0.2,0,0.5,0,0.7,0 c2.9-0.4,5-2.9,5-5.8C13,5.2,11.1,3.1,8.6,3C8.3,3,8.1,3,7.9,3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1109",
    transform: "translate(85.632 68.977)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3436",
    className: "st7",
    d: "M21.6,6c0,0-0.1-1.2,0.6-1.6c0.9-0.6,2.1-0.5,2.7,0.4c0,0,0,0.1,0.1,0.1c1,1.3,0.4,2.1,0,2.4 c-0.7,0.4-1.6,0.6-2.4,0.5C22.4,7.6,21.6,6,21.6,6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3437",
    className: "st7",
    d: "M16.5,4.8c0,0-0.3-2,1.5-2.3c1.1-0.1,2.2,0.4,2.9,1.3c0.5,0.6,0.5,1.3,0.3,2 c-0.6,1-2.3,1.8-2.8,1.5C17.8,6.4,17.1,5.6,16.5,4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3438",
    className: "st7",
    d: "M17.7,5.2c0,0-0.3-2,1.5-2.3c1.1-0.1,2.2,0.4,2.9,1.3c0.5,0.6,0.5,1.3,0.3,2 c-0.6,1-2.3,1.8-2.8,1.5C18.9,6.8,18.3,6,17.7,5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3439",
    className: "st8",
    d: "M23.1,6.1c-0.9-0.2-1.9,0-2.7,0.3c-0.9,0.6-1,2.4-0.9,3.1c0.5,1.1,1.5,1.8,2.7,1.9 c1-0.1,2.7-1.6,2.6-2.1C24.3,8.2,23.7,7.2,23.1,6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3440",
    className: "st9",
    d: "M16.7,5.6c-1-0.2-2.1-0.1-3,0.3c-1,0.7-1.1,2.7-1,3.5c0.6,1.2,1.7,2,3,2.1 c1.1-0.1,3-1.8,3-2.3C18.1,8,17.4,6.8,16.7,5.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1104",
    transform: "translate(5.569)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3441",
    className: "st8",
    d: "M5.4,10.8c0.3-0.6,0.8-1.1,1.4-1.3c0.8-0.3,1.7-0.3,2.5,0.1c0,0,1.1,2.6,0.9,3.9 s-3.3,1.5-3.7,0.7C6.1,13.1,5.7,12,5.4,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3442",
    className: "st7",
    d: "M0,10.8c0.3-0.6,0.8-1.1,1.4-1.3c0.8-0.3,1.7-0.3,2.5,0.1c0,0,1.1,2.6,0.9,3.9 s-3.3,1.5-3.7,0.7C0.7,13.1,0.3,12,0,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3443",
    className: "st7",
    d: "M7.9,6.5c0.6,0.6,1.4,0.9,2.3,1c1.1-0.2,2-0.9,2.5-2c0-0.3-0.1-2.8-2.3-2.5 C9.3,3,7.7,4.2,7.6,4.7C7.6,5.3,7.7,5.9,7.9,6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3444",
    className: "st10",
    d: "M10.6,5.2c0,0-0.1-0.5,0.1-0.6c0.2-0.1,0.4-0.1,0.6-0.1c0.1,0.1,0.1,0.1,0.2,0.1 c0.3,0.2,0.5,0.4,0.7,0.6L12,5.4c0,0-0.9-0.4-0.9-0.4C11,5.2,10.8,5.2,10.6,5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3445",
    className: "st10",
    d: "M8.3,8c0,0-0.6-0.4-0.8-0.5S7.3,7.2,7.2,7.3C7,7.5,7,7.7,7.2,7.9C7.3,8,7.6,7.9,7.8,8 C8,8.1,8.2,8.2,8.3,8.3L8.3,8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3446",
    className: "st11",
    d: "M4.4,5.5c-0.8,0-1.6,0.4-2,1.1c-0.4,0.7-0.4,1.6,0,2.4c0.2,0.5,0.7,0.9,1.2,1 c1,0.2,4-1.1,3.8-2.2C7,6.4,5.8,5.5,4.4,5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3447",
    className: "st12",
    d: "M11.1,3.4c0-0.1,0-0.2-0.1-0.3c0-0.1-0.1-0.1-0.2-0.1c0,0.1,0,0.1-0.1,0.2 c-0.1,0.2-0.2,0.4-0.3,0.6c0.2,0.1,0.3,0.1,0.5,0c0.2,0.1,0.4,0.2,0.6,0.4c0.3,0.3,0.4,0.6,0.5,0.9L12.3,5 C12.3,4.2,11.1,3.4,11.1,3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3448",
    className: "st11",
    d: "M9.6,0.3C8.6-0.2,7.4,0,6.7,0.8C6.2,1.3,6,2,6.1,2.7c0.7-0.1,1.4,0,2,0.4c0.6,0.3,1,1,1,1.7 c0.8-0.3,1.4-0.9,1.7-1.6C11.1,2,10.6,0.8,9.6,0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1105",
    transform: "translate(8.542 0.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3449",
    className: "st13",
    d: "M6,4.6c0.1-0.1,0.2,0,0.3,0.1C6.5,5,6.8,5.1,7.1,5.2c0.2,0.1,0.5,0.1,0.7,0 C8,5.2,8.3,4.8,8.5,4.7c0.2,0,0.4,0,0.7,0L9,5C8.6,5.2,8.2,5.4,7.8,5.6c-0.3,0-0.3,0.5-0.4,0.8c0,0.2,0,0.5,0,0.7L6.9,6.9 c0,0-0.1-0.1,0.1-0.6c0.1-0.2,0.2-0.5,0.4-0.7c0,0-0.1-0.2-0.2-0.2c-0.4,0-0.7,0-1.1,0C5.9,5.4,6,4.6,6,4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3450",
    className: "st11",
    d: "M5,8.5c0,0-0.4-1.4-1.6-1.5C2.4,6.7,1.2,7.1,0.5,7.9C0,8.6-0.2,9.5,0.2,10.3 c0.3,0.7,1,1.3,1.7,1.4c1,0.1,2-0.3,2.7-1C5.2,10.1,5.3,9.3,5,8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3451",
    className: "st7",
    d: "M5,11.9c0,0,0.1-0.8,1.3-1.1s2.3-0.1,2.7,0.5s0.9,2.6,0.1,3.4s-1.4,1.5-2.2,1.3 s-2.5-0.6-2.3-1.8S5,11.9,5,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3452",
    className: "st12",
    d: "M14.4,5.1c-0.6,0-1.2,0.1-1.7,0.4c-0.1-0.2-0.4-0.3-0.6-0.4c-0.1,0-0.2,0-0.3,0 c0.3,0.2,0.5,0.4,0.6,0.7c0.2,0.5,0.3,1,0.2,1.6c0.1-0.2,0-0.6,0.2-1c0.3-0.6,1.7-0.8,1.8-0.8S14.4,5.1,14.4,5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3453",
    className: "st10",
    d: "M12,8.7c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.1,0.1-0.2,0.1c0.5,0.4,1,0.8,1.4,1.2l0.6-0.2 C13.2,9.4,12.6,9,12,8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3454",
    className: "st14",
    d: "M7.9,7.4C7.7,6.8,7.8,6.1,8.1,5.5c0.5-0.7,1.4-1.1,2.3-1c0.8,0.1,1.6,0.6,2.1,1.3 c0.5,1,0.2,2.3-0.6,3C10.7,9.5,8.6,9.4,8.6,9C8.4,8.4,8.1,7.9,7.9,7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3455",
    className: "st11",
    d: "M8.7,13.5c0,0-1.3-1.5-0.7-2.6c0.3-0.9,1.1-1.5,2.1-1.6c1-0.2,2.5,0.3,2.7,1.3 s0.4,2.8-0.8,3.2C11,14,9.8,13.9,8.7,13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3456",
    className: "st14",
    d: "M7.1,6.9C6.5,6.8,5.9,7,5.5,7.5c-0.6,0.7-0.8,1.7-0.6,2.6C5,11,5.8,11.6,6.7,11.6 c1.2,0.1,2.2-0.8,2.3-2c0-0.3,0-0.6-0.2-0.9C8.2,6.9,7.1,6.9,7.1,6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3457",
    className: "st14",
    d: "M6.1,4.6c0.1-0.8-0.3-1.5-1-1.8C3.5,2,1.9,2.5,1.3,3.8c-0.4,1-0.2,2.1,0.6,2.8 c0.8,0.4,1.8,0.5,2.6,0.2c1-0.4,1.5-0.9,1.5-1.6C6.1,5.1,6.1,4.8,6.1,4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3458",
    className: "st14",
    d: "M14.3,0c-1-0.2-2,0.3-2.5,1.1c-0.7,1-0.4,2.4,0.6,3.1c1,0.7,2.4,0.6,3.3-0.3 c0.6-0.8,0.7-1.9,0.2-2.8C15.6,0.2,14.3,0,14.3,0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3459",
    className: "st10",
    d: "M27.6,10.6c0,0,0.4,0.4,0.7,0.8l0.1-0.2l-0.1-1C28.3,10.2,27.6,10.1,27.6,10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3460",
    className: "st7",
    d: "M28,11.3c0.5-0.5,1.2-0.8,1.9-0.8c0.9-0.1,1.9,0.4,2.2,1.3c0.2,0.7,0.1,1.3-0.1,2l-2.9,0.5 L28,11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3461",
    className: "st7",
    d: "M24,5.3c0.3-0.6,0.8-1.1,1.5-1.3c1-0.2,1.9,0.2,2.5,1c0.3,0.6,0.4,1.4,0.3,2.1l-2.4,1L24,5.3z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3462",
    className: "st12",
    d: "M24,5.1c0.3,0,0.6,0,1,0c0.6,0,1.1,0.5,2,0.3s1.9-0.4,2.8-0.5s1.4-0.1,1.4-0.1 c0.4-0.1,0.8-0.3,1.3-0.5c0.6-0.3,1.5-0.8,1.9-1s1.3-0.7,1.5-0.8c0.2-0.2,0.4-0.2,0.7-0.3c0.3,0,0.3,0.5,0.1,0.7 c-0.6,0.2-1.3,0.5-1.9,0.7c-1,0.5-2,1.1-3,1.8c-0.2,0.3-0.4,0.7-0.5,1.1c-0.1,0.2-0.3,0.5-0.5,0.7c-0.4,0.6-0.8,1.2-1.1,1.8 c-0.2,0.7-0.4,1.5-0.4,2.3l-0.5-0.1c0.1-0.8,0.3-1.5,0.7-2.2C30,8,30.9,6.6,30.9,6.6l0.2-1.1c-0.6,0-1.3,0-1.9,0.1 c-0.6,0.2-1.2,0.3-1.8,0.4l-0.4,0.8l-1.7-0.2L24,5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3463",
    className: "st11",
    d: "M30.8,12.9c0.6,0.2,1.1,0.5,1.6,0.9c0.6,0.6,0.8,1.6,0.5,2.4c-0.2,0.8-0.8,1.5-1.6,1.7 c-1.3,0.5-2.1,0.5-3.1-0.3c-0.8-0.8-1-2-0.5-3C28.2,13.2,28.8,12.3,30.8,12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3464",
    className: "st7",
    d: "M26.4,6.3c0,0,0.6-0.5,1.7,0.2c1.1,0.7,1.5,2.2,0.8,3.4c0,0,0,0,0,0.1c-0.6,0.6-1.4,1-2.3,1 c0,0-2-0.6-2-1.7S26.4,6.3,26.4,6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3465",
    className: "st10",
    d: "M25.9,14.2c0.1,0.1,0.3,0.2,0.4,0.3c0.3,0,0.6,0,0.9,0l0.2,0.4c-0.3,0.1-0.5,0.2-0.8,0.2 c-0.2,0-0.5-0.1-0.7-0.1l-0.2-0.3l0.3-0.1l-0.3-0.2l-0.1-0.3L25.9,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3466",
    className: "st7",
    d: "M27.5,11.6c0,0-0.2-0.4-0.3-0.6s0.2-0.8-0.8-1.3c-1-0.5-2.2-0.4-3.2,0.3 c-0.8,0.7-1.1,1.9-0.7,2.9c0.4,1.1,1.5,1.7,2.6,1.7C25.7,14.6,28.4,13.3,27.5,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3467",
    className: "st13",
    d: "M26.5,10.7c0.3,0.1,0.5,0,0.8-0.1c0.3-0.2,0.5-0.5,0.7-0.7l0.6-0.7l0.2,0.1 c-0.2,0.2-0.4,0.5-0.6,0.7c-0.3,0.4-0.7,0.8-1.1,1.1c0,0,0,0.2-0.2,0.2c-0.2,0-0.4-0.1-0.5-0.3C26.3,11,26.4,10.8,26.5,10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3468",
    className: "st7",
    d: "M24.9,13.9c-0.6-0.6-1.5-0.8-2.3-0.6c-1.5,0.4-2.4,1.9-2.1,3.4c0.3,1.5,2.2,1.9,3.1,1.6 s2.2-1.6,2.2-2.5C25.7,15,25.4,14.4,24.9,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3469",
    className: "st10",
    d: "M24.6,14.4c0.2-0.1,0.4-0.3,0.6-0.4c0.1,0,0.2-0.1,0.3-0.1c0,0-0.5,0.7-0.6,0.8 c0,0,0.1,0.2-0.1,0.3s-0.4-0.1-0.4-0.1s-0.2-0.3-0.1-0.4C24.4,14.4,24.5,14.4,24.6,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3470",
    className: "st10",
    d: "M21.2,14.7c0.4-0.2,0.9-0.4,1.4-0.5c0.6-0.1,1.8,0,2.3-0.1c0.4-0.1,0.9-0.2,1.3-0.3 c0.1,0,0.7-0.3,0.7-0.3l-0.2-0.3c-0.2,0.1-0.4,0.2-0.6,0.3c-0.2,0.1-0.6,0.2-0.7,0.1s-0.6-0.4-0.7-0.6l-0.4,0.5 c0.2,0,0.5,0.1,0.7,0.2c0,0,0.1,0.1,0.1,0.1c-0.3,0-0.6,0.1-0.9,0.1c-0.6,0-3.5,0.2-3.5,0.2L21.2,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3471",
    className: "st12",
    d: "M25.5,14.5c0.1,0.3,0.1,0.5,0.1,0.8c0,0.1-0.3,0.2-0.1,0.4l0,0c0.2,0,0.4,0,0.5,0 s0.3-0.2,0.4-0.2l0,0c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.2-0.2-0.5-0.2-0.7c0-0.2-0.1-0.4-0.1-0.6s-0.1-0.1-0.1-0.1s-0.2,0-0.2,0.2 C25.4,14.2,25.4,14.3,25.5,14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3472",
    className: "st11",
    d: "M19.1,16.8c-0.6,0.5-0.8,1.3-0.7,2.1c0.3,1.4,1.5,2.3,2.9,2.2c1.4-0.1,1.9-1.8,1.7-2.8 s-1.3-2.2-2.2-2.2C20.2,16.2,19.6,16.5,19.1,16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3473",
    className: "st11",
    d: "M26.5,15.3c0,0-0.4,0.2-0.6,0.3s-0.8-0.2-1.4,0.7c-0.5,1-0.5,2.2,0.1,3.2 c0.7,0.9,1.8,1.2,2.9,0.9c1.1-0.4,1.8-1.4,1.8-2.5C29.4,17.3,28.3,14.6,26.5,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3474",
    className: "st14",
    d: "M23.2,9.7c-0.8-0.3-1.7-0.2-2.4,0.3c-0.8,0.6-1.1,1.7-0.8,2.6c0.2,0.9,0.9,1.6,1.8,1.8 c1.3,0.3,2.6-0.4,3.1-1.5C25.2,11.5,24.5,10.1,23.2,9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3475",
    className: "st14",
    d: "M18.2,12.9c-0.9,0.2-1.8,0.8-2.2,1.7c-0.4,1-0.1,2.2,0.7,2.9c0.8,0.7,2,0.8,2.9,0.3 c1-0.4,1.6-1.3,1.6-2.3c0-0.8-0.4-1.6-1-2.2C19.7,12.6,18.2,12.9,18.2,12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3476",
    className: "st11",
    d: "M29.9,11.1c-0.9-0.2-1.8-0.1-2.6,0.4c-1.2,0.8-0.7,2.8-0.7,2.8c0.2,0.9,0.9,1.6,1.9,1.7 c1.2,0.1,2.3-0.6,2.7-1.7C31.4,13.4,31,11.6,29.9,11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3477",
    className: "st12",
    d: "M26.9,7.4c0.4,0.2,0.8,0.4,1.1,0.6c0.3,0.2,0.6,0.5,0.8,0.8c0,0,0.1,0.3,0.2,0.4 s0.5,0.2,0.5,0.2c0.1,0.1,0.1,0.2,0.1,0.2c0,0.2-0.3,0.2-0.3,0.2l-0.5-0.4c-0.1-0.2-0.2-0.4-0.3-0.6c-0.3-0.6-0.9-1-1.6-1.1 L26.9,7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3478",
    className: "st14",
    d: "M24.2,5.1c-1.1-0.1-2.1,0.5-2.5,1.5c-0.3,1.1,0.2,2.2,1.1,2.7c1,0.5,2.1,0.5,3.1,0.1 c0.6-0.4,1-1,1-1.7c0-0.7-0.2-1.3-0.7-1.8C25.7,5.5,25,5.2,24.2,5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3479",
    className: "st15",
    d: "M27.7,17.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3480",
    className: "st15",
    d: "M27.7,17.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3481",
    className: "st7",
    d: "M6.1,14c0,0-1.4,0.3-1.7,1.1S4,17.9,4.8,18.4c0.6,0.5,1.4,0.8,2.2,0.7c1.1,0,2.9-0.5,3-2.3 s-0.7-3.7-1.9-3.5C7.4,13.4,6.7,13.7,6.1,14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3482",
    className: "st11",
    d: "M10.9,17.6c0,0,0,1.5,0.9,2c1,0.5,2.2,0.4,3.1-0.2c0.8-0.7,1.1-1.8,0.9-2.9 c-0.2-1.2-1.9-2.7-4.5-1C10.7,15.9,10.9,17.6,10.9,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3483",
    className: "st13",
    d: "M3.8,18.4c0.4,0,0.7-0.1,1.1-0.1c0.3,0,0.6-0.2,0.8-0.5c0.1-0.2,0.2-0.7,0.4-1 s0.5-0.7,0.5-0.8s0-0.1-0.4-0.2s-1.2,0-1.2,0l-0.1-0.6c0.2,0.1,0.5,0.1,0.7,0.2c0.2,0,0.3-0.2,0.4-0.2c0.1,0,0.2,0,0.4,0.1 c0,0,0.1,0.2,0.2,0.2c0.1,0,0.2,0,0.3,0.1c0,0,0.7-0.6,1.1-1s1.4-1,1.6-1.2c0.3-0.3,0.7-0.5,1-0.9c0.1-0.2,0.7-0.4,0.7-0.4 l0.3-0.1c-0.5,0.6-1.1,1.2-1.7,1.7c-0.8,0.6-1.6,1.2-2.4,1.9C7,16,6.7,16.3,6.4,16.7c-0.1,0.4-0.2,0.7-0.3,1.1 c-0.1,0.1,0.3,0.8,0.3,0.8l-0.4,0.2l-0.1-0.6c-0.4,0.3-0.9,0.5-1.4,0.5c0,0-0.5,0.4-0.5,0.7S2.7,19,2.7,19l0.2-0.7L3.8,18.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1106",
    transform: "translate(4.508 10.097)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3484",
    className: "st12",
    d: "M6.2,2.3C5.7,2.2,5.2,2,4.9,2v0C5,2.2,5,2.3,5,2.5h1C6.1,2.4,6.2,2.3,6.2,2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3485",
    className: "st14",
    d: "M4.9,2c0-0.6-0.3-1.2-0.9-1.5C2.9,0,1.4-0.6,0.4,1.1C-0.3,2.1,0,3.4,1,4.1 c0,0,0.1,0.1,0.2,0.1c1,0.4,2.2,0.2,3.1-0.4C4.8,3.4,5.1,2.7,4.9,2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1107",
    transform: "translate(7.294 11.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3486",
    className: "st14",
    d: "M4.1,4.6C3.4,4.1,2.8,3.4,2.7,2.5C2.4,2.4,2.1,2.3,1.8,2.4C0.8,2.8,0.1,3.8,0,4.9 c0.1,0.9,0.6,1.6,1.4,1.9C2,7,2.5,7,3,6.8c0.7-0.5,1.2-1.3,1.2-2.1C4.2,4.6,4.2,4.6,4.1,4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3487",
    className: "st14",
    d: "M6.2,0.2c-0.6-0.3-1.3-0.3-1.9,0c-0.8,0.3-1.4,1-1.5,1.9c0,1,0.5,1.9,1.4,2.4 C5,5,6.1,4.9,6.7,4.1c0.6-0.6,0.9-1.6,0.6-2.4C7.1,1.1,6.7,0.6,6.2,0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1108",
    transform: "translate(0 13.894)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3488",
    className: "st14",
    d: "M4.2,4.4c0.5-0.3,0.9-0.8,1-1.4c0.1-0.9-0.2-3.5-3-2.9C0.9,0.2-0.1,1.5,0.1,2.8 c0,0.3,0.1,0.5,0.2,0.8C0.6,4.4,1.5,5,2.4,4.9C3,5,3.7,4.8,4.2,4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3489",
    className: "st14",
    d: "M6.4,4.5c-1,0.3-1.7,1.3-1.7,2.3C4.7,8,5.5,9,6.6,9.4c1.2,0.3,2.3-0.4,2.7-1.6 c0.6-1.2,0.2-2.6-1-3.3c0,0,0,0,0,0C7.6,4.3,7,4.3,6.4,4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3490",
    className: "st14",
    d: "M1.1,5.2C0.4,5.7-0.1,6.6,0,7.6c0.1,1.3,1.3,2.3,2.6,2.2C4,9.7,5,8.5,4.8,7.2 c0-0.1,0-0.2,0-0.3c-0.4-2.1-1.4-2-2.3-2.1C2.1,4.8,1.6,4.9,1.1,5.2z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3491",
    className: "st1",
    d: "M93.6,50.9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFoodGrapes);
export default __webpack_public_path__ + "static/media/icon-food-grapes.08b2f8759a620ee740ee75f0d2a2f5a6.svg";
export { ForwardRef as ReactComponent };